import "./InstagramButton.css";

/**
 * 좌측 하단, 피드백 버튼 바로 위.
 *
 * 앱을 쓰는 사람에게는 별 쓸모가 없다 — 이미 들어와 있으니까. 검색으로
 * 흘러들어온 사람과, 아직 가입할 마음은 아닌 사람에게 남는 연결고리다.
 * 그래서 피드백과 같은 무게(테두리만)로 두고, 주된 동작들과 경쟁시키지 않는다.
 *
 * 로고는 직접 그린다. 이모지는 색도 모양도 기기마다 달라 이 화면에 섞이지 않고,
 * 이미지 파일은 한 줄짜리 버튼에 요청을 하나 더 만든다.
 */
const URL = "https://www.instagram.com/09muroo/";

const InstagramButton = () => (
  <a
    className="ig-fab"
    href={URL}
    target="_blank"
    rel="noopener noreferrer"
    title="MUROO 인스타그램 · @09muroo"
    aria-label="MUROO 인스타그램 (@09muroo) 새 창에서 열기"
  >
    <svg className="ig-fab-icon" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
      <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="17.4" cy="6.6" r="1.2" fill="currentColor" />
    </svg>
    <span className="ig-fab-label">09muroo</span>
  </a>
);

export default InstagramButton;
